import { SprievodnyDokumentZipApi } from 'evidencna-aplikacia-frontend-ts-axios';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ClientResponse } from '../../../model/ClientResponse';
import Uuid from '../../../model/Uuid';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import getFileName from '../../../function/getFileName';

const client = new SprievodnyDokumentZipApi(apiConfiguration(evidenciaPrefixPath));

interface ResponseType {
  fileName: string;
  blob: Blob;
}

// eslint-disable-next-line import/prefer-default-export
export const fetchSprievodneDokumentyZip = async (uuid: Uuid, stadium: StadiumMaterialuEnum, headers?: object):
  Promise<ClientResponse<ResponseType>> => {
  const {
    data,
    status,
    headers: headersResponse,
  } = await client.getSprievodnyDokumentZip(uuid, stadium, { ...headers, responseType: 'blob' });
  const blob = new Blob([data] as unknown as BlobPart[], { type: 'application/zip' });
  const fileName = getFileName(headersResponse);
  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};
